import { createPortal } from "react-dom";
import cross from "../assets/svgs/cross.svg";
import { ReactSVG } from "react-svg";
import Button from "./form/Button";
import Session from "../utils/sessionStorage";
import axiosInstance from "../utils/axiosInstance";
import { X_API_KEY } from "../constants/ServerUrl";
import { useState } from "react";
import loadingimage from "../assets/gifs/loading (1).gif";
import SuccessModal from "./SuccessModal";
import ErrorModal from "./ErrorModal";

const Confirmation = ({ close, actionType }) => {
  const result = Session.get("_user_");
  const userData = result ? JSON.parse(result) : "";
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleUnscribe = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `api/v1/end-subscription?msisdn=${userData?.mobileNo}`,
        {},
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setSuccessMessage("Unsubscribed Successfully");
        setShowSuccess(true);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "An error occurred");
      setShowError(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleStopRecurring = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `api/v1/end-recurring-data-subscription?msisdn=${userData?.mobileNo}`,
        {},
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setSuccessMessage("Recurring subscription stopped successfully");
        setShowSuccess(true);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "An error occurred");
      setShowError(true);
    }
    finally {
      setLoading(false);
    }
  };
  const handleConfirmAction = () => {
    if (actionType === 'stopRecurring') {
      handleStopRecurring();
    } else {
      handleUnscribe();
    }
  };

  const getConfirmationText = () => {
    if (actionType === 'stopRecurring') {
      return "Are you sure you want to stop recurring data subscription?";
    } else {
      return "Are you sure you want to Unsubscribe data packages?";
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    close();
  };

  const handleErrorClose = () => {
    setShowError(false);
    close();
  };

  if (showSuccess) {
    return <SuccessModal close={handleSuccessClose} message={successMessage} button1={"OK"} />;
  }

  if (showError) {
    return <ErrorModal close={handleErrorClose} message={errorMessage} />;
  }

  return createPortal(
    <div className=" overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0  max-h-full bg-black bg-opacity-50">
      <div className="relative p-4 w-full max-w-md max-h-full">
        <div className="relative px-7 py-6 bg-white rounded-3xl shadow ">
          {!loading ? (
            <>
              <div className="absolute top-3 right-5">
                <button
                  type="button"
                  className="end-2.5  text-gray-400 cursor-pointer hover:bg-gray-200  rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center  "
                  onClick={close}
                >
                  <ReactSVG src={cross} />
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="relative mt-5 p-4">
                <p className="text-[17px] font-semibold pb-6 text-center">
                  {getConfirmationText()}
                </p>
                <div className="grid grid-cols-2 gap-4 ">
                  <Button
                    classes={"text-primary border border-primary bg-white"}
                    roundness={"pill"}
                    type={"button"}
                    size={"costum"}
                    intent={"more"}
                    children={"No"}
                    eventAction={close}
                  />
                  <Button
                    children={"Yes"}
                    intent={"primary"}
                    size={"md"}
                    roundness={"round"}
                    eventAction={handleConfirmAction}
                    disabled={loading} // disable when loading
                  />

                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col gap-2 items-center justify-center pb-7">
                <img src={loadingimage} alt="loading" className="w-20 h-20" />
                <h1 className="text-[17px] font-semibold text-primary">Please wait...</h1>
              </div>
            </>
          )}
        </div>
      </div>
    </div>,

    document.body
  );
};

export default Confirmation;
